// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"61fa020186a0a9d802ad","655":"d3c17e8331e67d955e3a"}[chunkId] + ".js";
};